import { IAppTranslations } from "./translationsTypes";
import noEthereumProviderSectionTranslationsJson from "./locales/ko/noEthereumProviderSection.json";
import commonsTranslationsJson from "./locales/ko/commons.json";
import domainTranslationsJson from "./locales/ko/domain.json";
import modalsJson from "./locales/ko/modals.json";
import accountConnectionSectionTranslationsJson from "./locales/ko/accountConnectionSection.json";
import explanationTextsJson from "./locales/ko/explanationsTexts.json";
import headerTranslationsJson from "./locales/ko/header.json";
import registerGuardianSectionTranslationsJson from "./locales/ko/registerGuardianSection.json";
import delegatingToAnotherSectionTranslationsJson from "./locales/ko/delegatingToAnotherAccountSection.json";
import guardianDataFormsTranslationsJson from "./locales/ko/gaurdianDataForms.json";
import guardianEditPageTranslationsJson from "./locales/ko/guardianEditPage.json";

export const KOREAN_TEXTS: IAppTranslations = {
  noEthereumProviderSection: noEthereumProviderSectionTranslationsJson,
  commons: commonsTranslationsJson,
  domain: domainTranslationsJson,
  modals: modalsJson,
  accountConnectionSection: accountConnectionSectionTranslationsJson,
  explanationsTexts: explanationTextsJson,
  header: headerTranslationsJson,
  registerGuardianSection: registerGuardianSectionTranslationsJson,
  delegatingToAnotherAccountSection: delegatingToAnotherSectionTranslationsJson,
  guardianDataForms: guardianDataFormsTranslationsJson,
  guardianEditPage: guardianEditPageTranslationsJson,
};
